import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Building2 } from 'lucide-react';
import Sidebar from '../sidebar/sidebar';
import Header from '../header';
import { OWN_TENANT_PAGES, ownTenantMenus } from '../../common/Utils/tenantScope';

const ROLE_LABELS: Record<string, string> = { globaladmin: 'Global admin', reseller: 'Reseller' };

/**
 * Shown instead of a page that needs a customer tenant while a Globaladmin/reseller has their own tenant selected.
 * "Select a tenant" goes to Tenant Management and remembers this page, so choosing a tenant there comes back here.
 */
const SelectTenantNotice = ({ role }: { role: string }) => {
  const location = useLocation();
  const pages = ownTenantMenus(role)
    .map((key) => OWN_TENANT_PAGES[key])
    .filter(Boolean);

  return (
    <div className="flex">
      <Sidebar />
      <div className="flex-1 min-h-screen" style={{ backgroundColor: 'rgb(7, 7, 7)' }}>
        <Header title="Select a tenant" dropdown={2} />
        <main className="flex justify-center px-6 py-16">
          <section
            aria-labelledby="select-tenant-title"
            className="w-full max-w-xl rounded-xl border border-zinc-800 bg-[#141414] p-8 text-center text-white"
          >
            <div className="mx-auto mb-5 flex h-12 w-12 items-center justify-center rounded-full border border-red-800 bg-[#2d0a0a] text-red-300">
              <Building2 size={22} aria-hidden="true" />
            </div>
            <h1 id="select-tenant-title" className="text-xl font-semibold">
              Select a tenant to open this page
            </h1>
            <p className="mt-3 text-sm leading-relaxed text-gray-400">
              You&apos;re in your own {ROLE_LABELS[role] ?? ''} tenant. This page shows a customer tenant&apos;s data, so choose a tenant in
              Tenant Management first.
            </p>
            <Link
              to="/customers"
              state={{ from: location.pathname + location.search }}
              className="mt-6 inline-flex items-center gap-2 rounded-lg bg-red-600 px-5 py-2.5 text-sm font-semibold text-white no-underline transition-colors hover:bg-red-700"
            >
              Select a tenant
            </Link>
            {pages.length > 0 && (
              <div className="mt-8 border-t border-zinc-800 pt-5 text-sm text-gray-400">
                <div className="mb-2">Available in your own tenant:</div>
                <ul className="m-0 flex list-none flex-wrap justify-center gap-x-4 gap-y-2 p-0">
                  {pages.map((page) => (
                    <li key={page.path}>
                      <Link to={page.path} className="text-gray-200 underline-offset-4 hover:text-white hover:underline">
                        {page.label}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            )}
          </section>
        </main>
      </div>
    </div>
  );
};

export default SelectTenantNotice;
